import { createEnvironmentStore } from '@nova-integration/ui-shared';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const useEnvironmentStore = createEnvironmentStore({ apiBaseUrl: API_BASE_URL });
